import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {CoastingIcon.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a coasting icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <CoastingIcon width={12} />
 */
const CoastingIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M21.28,15.08l4.86-7.6,4.64,7.74-3.19-1.13-0.06,4-3.09,0,0.06-4ZM8.65,38.6a1,1,0,1,0,0,1.92H41.58a1,
            1,0,0,0,0-1.92H38.36l-2.24-7.66,3.84-2a1.44,1.44,0,0,0-1.35-2.55l-9.39,5a1.44,1.44,0,1,0,1.35,
            2.55l3.23-1.71,1.88,6.44H17.21l4.68-3.72-1.2-1.38a37.71,37.71,0,0,0,9.12-5.41c5.58-4.36,7-7.54,
            7.38-8.31s-1.4-2.07-2.28-2.1-3.83,1.94-6.18,2.83a25,25,0,0,1-5.5,1.69l-2.17.39-3.73-3.76a19.11,19.11,
            0,0,0-6.53,5.66c-3.08,4-5.35,4.83-5.35,4.83L9,32.93a11.08,11.08,0,0,0,1.26,2.22,26.71,26.71,
            0,0,0,3,3.44H8.65`}
        />
    </SvgIcon>
)

CoastingIcon.defaultProps = defaultProps

export { CoastingIcon }
